<template>
  <div class="my-auto text-white">
    <div class="text-center">
      <h3 class="mt-0 text-sidebar-title mb-4">{{ $t('login.title') }}</h3>
    </div>
    <form @submit.prevent="login" id="auth-form">
      <div class="mb-3">
        <label for="email" class="form-label">Email</label>
        <input class="form-control" v-model="email" type="email" required maxlength="254" :placeholder="$t('login.emailPlaceholder')">
      </div>
      <div class="mb-3">
        <router-link to="/recoverypwd" class="text-sidebar-forget-pwd float-end"><small>{{ $t('login.forgotPassword') }}</small></router-link>
        <PasswordComponent v-model="password" autocomplete="current-password" tabindex="2" />
      </div>
      <div class="mb-3">
        <div class="form-check">
          <input type="checkbox" v-model="rememberMe" class="form-check-input" id="checkbox-signin">
          <label class="form-check-label" for="checkbox-signin">{{ $t('login.rememberMe') }}</label>
        </div>
      </div>
      <div v-if="cguAccepted != null" class="mb-3">
        <div class="form-check">
          <input type="checkbox" v-model="cguAccepted" class="form-check-input" id="checkbox-cgu">
          {{ $t('common.termsAgreement') }} <a href="/cgu-installers" target="_blank" rel="noopener noreferrer" style="color: white; text-decoration: underline;">{{ $t('common.termsOfUse') }}</a>
        </div>
      </div>
      <div class="d-grid mb-0 text-center">
        <button class="btn btn-info" type="submit" :disabled="cguAccepted === false">{{ $t('login.submit') }}</button>
      </div>
      <div v-if="errorMessage" class="mt-2 text-white">
        {{ errorMessage }}
        <div v-if="resend" class="mt-1">
          <p class="text-white">{{ $t('login.noEmail') }} <a href="javascript:void(0);" @click="resendLink" class="text-sidebar-link ms-1"><b>{{ $t('common.clickHere') }}</b></a></p>
        </div>
      </div>
    </form>

  </div>

  <!-- Footer -->
  <footer class="footer footer-alt">
    <p class="text-white">{{ $t('login.noAccess') }}
        <router-link to="/app-setup">
            <a class="text-sidebar-link ms-1"><b>{{ $t('common.clickHere') }}</b></a>
        </router-link>
    </p>
  </footer>
</template>

<script>
import { useUserStore } from '@/stores/userStore';
import { useRouter } from 'vue-router';
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';
import PasswordComponent from '@/components/password';

export default {
  name: 'LoginPage',
  components: {
    PasswordComponent
  },
  setup() {
    const userStore = useUserStore();
    const router = useRouter();
    const { t } = useI18n();

    const email = ref("");
    const password = ref("");
    const rememberMe = ref(false);
    const errorMessage = ref("");
    const cguAccepted = ref(null);
    const resend = ref(false);

    email.value = process.env.VUE_APP_USERNAME;
    password.value = process.env.VUE_APP_PASSWORD;

    let mail = localStorage.getItem('userEmail');
    if(mail) {
      email.value = mail;
      rememberMe.value = true;
    }

    const login = async () => {
      try {
        const path = await userStore.login(email.value, password.value, cguAccepted.value);
        if(rememberMe.value) {
          localStorage.setItem('userEmail', email.value)
        }
        router.push({ path: path });
      } catch (error) {
        switch(error) {
          case "AccountDeletionInProgress":
            errorMessage.value = t('login.errors.deletionInProgress');
            break;
          case "AccountNotActivated":
            errorMessage.value = t('login.errors.notActivated');
            resend.value = true;
            break;
          case "LoginFailed":
            errorMessage.value = t('login.errors.badCredentials');
            resend.value = false;
            break;
          default:
            errorMessage.value = error;
            resend.value = false;
            break;
        }
      }
    };

    const resendLink = async () => {
      const success = await userStore.resendActivationLink(email.value);
      if(success) {
        router.push({ path: "/result", query: {success: true, title: t('common.done'), message: t('login.resendSuccess')} });
      } else {
        router.push({ path: "/result", query: {success: false, title: t('common.sorry'), message: t('login.resendError')} });
      }
    };

    return {
      email,
      password,
      rememberMe,
      errorMessage,
      login,
      resend,
      resendLink,
      cguAccepted,
    };
  },
};
</script>
